import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, StatusCode, WebSiteRequestViewModel, WebSiteStatusViewModel, WebUrlViewModel} from "../../core/api/models";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { DeveloperApiService } from "../../core/api/services";
import { DomSanitizer } from "@angular/platform-browser";
import { formatDate } from "@angular/common";
import * as UAParser from 'ua-parser-js';
import moment from "moment";
import { LegendPosition } from "@swimlane/ngx-charts";




@Component({
  selector: 'app-web-site-view-component',
  templateUrl: './web-site-view.component.html',
  standalone: false
})
export class WebSiteViewComponent implements OnInit, AfterViewInit {



  public pageTitle: string = 'Web Site';


  currentItem?: WebSiteStatusViewModel;
  webSiteRequests?: WebSiteRequestViewModel[] | null | undefined;
  webUrls?: WebUrlViewModel[] | null | undefined;

  legendPosition = LegendPosition.Below;
  webUrlsData: any[] = [];

  loading: boolean = false;
  loadingLists: boolean = false;
  


  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: DeveloperApiService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      let ID = +(params.get('ID') || '0');
      if (ID > 0) {
        console.info('Loading SiteId ' + ID);

        this.apiService.ListWebSiteStatuses({
          body:
          {
            filters: {
              SiteId: [{
                Value: ID,
                MatchMode: 'eq'
              }]
            }
          }
        })
          .forEach(data => {
            this.loading = false;
            if (data.Result && data.Result.length > 0) {
              this.load(data.Result[0]);
            } else {
              this.alertService.info('No web site found with the specified Site ID.');
            }
          }).catch(
            err => {
              this.alertService.error(Utils.getAjaxError(err));

            });

      } else {
        this.router.navigate(['/exceptionlog']);
      }
    });

    this.authService.checkIfAutorized([ArkUserType.Developer, ArkUserType.Admin]);

  }

  ngAfterViewInit(): void {
    
  }


  async load(data: WebSiteStatusViewModel) {

    this.currentItem = data;

    this.loadingLists = true;
    this.apiService.ListWebSiteRequests({
      body: {
              filters: {
          WebSiteID: [{
            Value: data.ID,
                  MatchMode: 'eq'
                }]
              }
            }
      })
      .forEach(
        (result) => {
          this.webSiteRequests = result.Result;
          this.loadingLists = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingLists = false;
          });


    this.apiService.ListWebUrls({
      body: {
        filters: {
          WebSiteID: [{
            Value: data.ID,
            MatchMode: 'eq'
          }]
        }
      }
    })
      .forEach(
        (result) => {
          this.webUrls = result.Result;
          this.loadingLists = false;

          if (this.webUrls) {

            var chartData: any[] = [];

            //var startTime = moment.tz(new Date(), 'America/Denver');

            for (var webUrl of this.webUrls) {

              if (!webUrl.StatusJson)
                continue;

              var itemData = JSON.parse(webUrl.StatusJson);

              if (!itemData.History || !itemData.History.length)
                continue;



              var itemTime = moment.tz(webUrl.RequestDate, 'America/Denver');
              /*
              if (environment.production
                && itemTime.utc().diff(moment.utc(), 'minutes') < -30) {
                continue;
              }
              */

              var item = {
                name: webUrl.UrlName,
                series: [] as any[]
              };
              chartData.push(item);

              var timeStep = webUrl.MinPoolInterval ?? 30;
              var itemTime = itemTime.add((itemData.History.length * -1 + 1) * timeStep, 'seconds');

              for (var historyItem of itemData.History) {

                item.series.push({
                  value: (historyItem >= 0) ? historyItem : historyItem * -1,
                  name: itemTime.toDate()//.format('ddd, MMMM Do, YYYY [at] h:mm:ss A')
                });
                itemTime = itemTime.add(timeStep, 'seconds');
              }
            }
            this.webUrlsData = chartData;
          }


        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingLists = false;
          });
    
  }

  GetStatusText(item: WebSiteStatusViewModel |
    null | undefined): string | null {
    if (!item || item.StatusCode === undefined || item.StatusCode === null) {
      //return 'Unknown';
      return null;
    }
    let status = item.StatusMessage;

    if (!status || status.length == 0) {
      switch (item.StatusCode) {
        case StatusCode.Ok:
          //status = 'OK';
          return null;
          break;
        case StatusCode.Fail:
          status = 'Fail';
          break;
        case StatusCode.None:
          return null;
          status = 'None';
          break;
        case StatusCode.Warn:
          status = 'Warn';
          break;
        default:
          return null;
        //status = 'Unknown';
      }
    }

    return status;
  }

  GetStatusColor(item: WebUrlViewModel |
    WebSiteStatusViewModel |
    null | undefined): string {
    if (!item || item.StatusCode === undefined || item.StatusCode === null) {
      return 'info';
    }


    switch (item.StatusCode) {
      case StatusCode.Ok:
        return 'success';
      case StatusCode.Fail:
        return 'danger';
      case StatusCode.None:
        return 'secondary';
      case StatusCode.Warn:
        return 'warning';
      default:
        return 'info';
    }
  }



  formatByteSize(value: any): string {
    if (value === null || value === undefined)
      return '-';

    return Utils.formatByteSize(value );
  }


  formatByteSizeMB(value: any): string {
    if (value === null || value === undefined)
      return '-';

    return Utils.formatByteSize(value * 1024 * 1024);
  }

  formatPercentage(value: any, total: any): string {
    if (value === null || value === undefined
      || total === null || total === undefined || total === 0)
      return '-';

    return ((value / total) * 100).toFixed(1) + '%';
  }


  getRuntime(value: any): string {
    if (value === null || value === undefined)
      return '-';
    var t = new Date(value);
    // convert value from Mountain Time to local time

    const mountainTime = moment.tz(value, 'America/Denver');

    //var localTime = moment(mountainTime).utc().tz(moment.tz.guess() || 'Local');

    return mountainTime.fromNow();


    var now = new Date();
    var diff = now.getTime() - t.getTime();
    var seconds = Math.floor(diff / 1000);
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);

    return days + 'd ' + (hours % 24) + 'h ' + (minutes % 60) + 'm';

  }


  onChartSelect(data: any): void {

    console.log('Item clicked', JSON.parse(JSON.stringify(data)));

    this.alertService.info(`${data.series}: ${data.value}ms \r\n ${Utils.formatMountainTime(data.name)} `)
  }
}
